import { render, staticRenderFns } from "./DataForDepositBankForm.vue?vue&type=template&id=70aeff42&scoped=true&"
import script from "./DataForDepositBankForm.vue?vue&type=script&lang=js&"
export * from "./DataForDepositBankForm.vue?vue&type=script&lang=js&"
import style0 from "./DataForDepositBankForm.vue?vue&type=style&index=0&id=70aeff42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aeff42",
  null
  
)

export default component.exports